import { useEffect, useState } from 'react';

const LOGO_URL = 'https://static.readdy.ai/image/dfc6db26b98ba2c0b04cea29bf715fac/72800120cdbe3fd9576126c278bba12a.png';
const BG_IMAGE = 'https://public.readdy.ai/ai/img_res/83f6a205bf7657ffd2fe5315938d8949.jpg';
const CHECKOUT_URL = 'https://elabooks.com/checkouts/cn/hWN9vdijShZFrxH7cDKM5m5K/es-us?_r=AQABk6Gs2YiKxpZaPCLClghqTNRHI_0VO_9pIDDMnwLCZD8&auto_redirect=false&edge_redirect=true&skip_shop_pay=true';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={BG_IMAGE}
          alt="Familia organizando sus finanzas"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-emerald-950/80 via-emerald-900/70 to-emerald-950/85" />
      </div>

      {/* Navbar */}
      <nav className="relative z-20 w-full px-6 md:px-12 py-5 flex items-center justify-between">
        <img src={LOGO_URL} alt="ElaBooks Logo" className="h-10 md:h-12 object-contain" />
        <a
          href={CHECKOUT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="whitespace-nowrap bg-amber-400 hover:bg-amber-300 text-emerald-950 font-semibold text-sm px-5 py-2.5 rounded-full cursor-pointer transition-all duration-300"
        >
          Quiero el Programa →
        </a>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 flex-1 flex items-center justify-center px-6 md:px-12 py-16 w-full">
        <div
          className={`w-full max-w-4xl mx-auto text-center transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <span className="inline-block bg-amber-400/20 border border-amber-400/40 text-amber-300 text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-6">
            Programa Digital · 30 Días
          </span>

          <h1
            className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Recupera el{' '}
            <span className="text-amber-400">Control Financiero</span>{' '}
            de tu Familia
          </h1>

          <p className="text-emerald-100 text-lg md:text-xl max-w-2xl mx-auto mb-4 leading-relaxed">
            El sistema práctico de 30 días que reorganiza las finanzas de tu hogar, elimina deudas y crea hábitos económicos saludables para toda la familia.
          </p>

          <p className="text-amber-300 font-semibold text-base md:text-lg mb-10">
            Sin conocimientos financieros avanzados. Solo un plan claro que funciona.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap w-full sm:w-auto bg-amber-400 hover:bg-amber-300 text-emerald-950 font-bold text-lg px-10 py-4 rounded-full cursor-pointer transition-all duration-300 transform hover:scale-105 text-center"
            >
              Acceder al Programa por $17 USD
            </a>
            <button
              onClick={() => document.getElementById('beneficios')?.scrollIntoView({ behavior: 'smooth' })}
              className="whitespace-nowrap w-full sm:w-auto border border-white/30 hover:border-white/60 text-white font-medium text-base px-8 py-4 rounded-full cursor-pointer transition-all duration-300"
            >
              Ver qué incluye ↓
            </button>
          </div>

          {/* Social proof */}
          <div className="mt-12 flex flex-wrap justify-center gap-8 text-sm text-emerald-200">
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shield-check-line text-amber-400 text-lg" />
              </div>
              <span>Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-download-line text-amber-400 text-lg" />
              </div>
              <span>Descarga Digital</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-time-line text-amber-400 text-lg" />
              </div>
              <span>30 Días de Programa</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-family-line text-amber-400 text-lg" />
              </div>
              <span>Para toda la familia</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="relative z-10 flex justify-center pb-8 animate-bounce">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/50 text-2xl" />
        </div>
      </div>
    </section>
  );
}
